/** Field definitions for the bilingual showroom forms (labels printed in both languages, like the paper). */
export const SF_TITLES = {
  owner_auth: ["AUTHORIZATION OF SELLING & PURCHASING OF AUTOMOBILES", "تفويض بيع وشراء السيارات"],
  sale_contract: ["CONTRACT OF SALE", "عقد بيع"],
};

export const SF_FIELDS = {
  owner_auth: [
    ["Second party (owner)", "الطرف الثاني (المالك)", [
      ["owner_name", "Mr.", "السيد", "text", true],
      ["owner_mobile", "Phone", "الهاتف", "tel", true],
      ["owner_work_place", "Place of work", "جهة العمل", "text"],
      ["owner_civil_id", "ID card number", "رقم البطاقة", "text"],
    ]],
    ["Vehicle", "المركبة", [
      ["make", "Make / brand", "الصانع / العلامة التجارية", "text", true],
      ["model", "Model", "الموديل", "text", true],
      ["body_type", "Body type (optional: SUV, Sedan…)", "نوع الهيكل (اختياري: دفع رباعي، سيدان…)", "text"],
      ["model_year", "Year", "سنة الصنع", "number"],
      ["plate_number", "Registration (plate) number", "رقم التسجيل (اللوحة)", "text"],
      ["colour", "Colour", "اللون", "text"],
      ["odometer_km", "Odometer (km)", "قراءة العداد (كم)", "number"],
      ["initial_price", "Initial price (OMR)", "السعر المبدئي (ر.ع)", "money"],
    ]],
  ],
  sale_contract: [
    ["Second party (buyer)", "الطرف الثاني (المشتري)", [
      ["buyer_name", "Mr.", "السيد", "text"],
      ["buyer_civil_id", "ID card number (resident)", "رقم البطاقة (مقيم)", "text"],
      ["buyer_mobile", "Mobile", "الهاتف النقال", "tel"],
      ["buyer_work_phone", "Work phone", "هاتف العمل", "tel"],
      ["buyer_work_place", "Work place", "جهة العمل", "text"],
    ]],
    ["Vehicle", "المركبة", [
      ["make", "Make / brand", "الصانع / العلامة التجارية", "ro"],
      ["model", "Model", "الموديل", "ro"],
      ["body_type", "Body type", "نوع الهيكل", "ro"],
      ["plate_number", "Plate number", "رقم اللوحة", "ro"],
      ["colour", "Colour", "اللون", "ro"],
      ["engine_number", "Engine number", "رقم المحرك", "text"],
      ["chassis_number", "Chassis number", "رقم الشاصي", "ro"],
    ]],
    ["Amounts", "المبالغ", [
      ["selling_price", "Total price (OMR)", "السعر الإجمالي (ر.ع)", "money", true],
      ["discount_amount", "Discount (OMR)", "الخصم (ر.ع)", "money"],
      ["deposit_paid", "Amount paid as deposit", "المبلغ المدفوع كعربون", "ro-money"],
      ["remaining", "The rest (remaining)", "المبلغ المتبقي", "ro-money"],
      ["fine_amount", "Return fine (RO)", "غرامة الإرجاع (ر.ع)", "money"],
      ["extra_condition_5", "Condition 5", "الشرط 5", "text"],
      ["extra_condition_6", "Condition 6", "الشرط 6", "text"],
    ]],
  ],
};

export const SF_PARTIES = {
  owner_auth: [["customer", "Second party (owner)", "الطرف الثاني (المالك)"], ["staff", "First party (showroom)", "الطرف الأول (المعرض)"], ["manager", "Sales manager", "مدير المبيعات"]],
  sale_contract: [["customer", "Buyer", "المشتري"], ["staff", "Seller (showroom)", "البائع (المعرض)"], ["manager", "Sales manager", "مدير المبيعات"]],
};

export const omr = (v) => (v === null || v === undefined || v === "" ? "—" : `OMR ${Number(v).toLocaleString("en-US", { minimumFractionDigits: 3, maximumFractionDigits: 3 })}`);
